import { ConfiguratorTabs } from "stores/product";

export type MenuItem = {
  title: string;
  tab: ConfiguratorTabs;
};

export const MENU_ITEMS: MenuItem[] = [
  {
    title: "PRODUCT_CONFIGURATOR_TECHNICAL_DESIGN",
    tab: ConfiguratorTabs.TECHNICAL_DESIGN,
  },
  {
    title: "PRODUCT_CONFIGURATOR_PRODUCT_SPECIFICATION",
    tab: ConfiguratorTabs.PRODUCT_SPECIFICATION,
  },

  {
    title: "PRODUCT_CONFIGURATOR_DOWNLOADS",
    tab: ConfiguratorTabs.DOWNLOADS,
  },
];
